import { GetTokenSilentlyOptions, LogoutOptions } from '@auth0/auth0-react';
import { store } from '../redux/store';
import { isTokenExpired } from '../utils/isTokenExpired';
import refreshTokenOrLogout from '../utils/refreshTokenOrLogout';
import fetchWithRetry from './fetchWithRetry';
import { PostHog } from 'posthog-js';
import { captureLearnosityException, logLearnosityInfo } from '../utils/learnositySentry';

const assessmentEndpoints = {
  diagnostic: 'diagnostics/submit-success',
  skill: 'assessments/submit-success',
  exitslip: 'exitslip/submit-success',
};

export const assessmentSubmitted = async (
  sessionId: string,
  type: 'diagnostic' | 'skill' | 'exitslip',
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>,
  logout: (options?: LogoutOptions) => Promise<void>,
  posthog: PostHog,
  classExitSlipId?: string,
  sentryTraceId?: string,
  learnerId?: string,
) => {
  let accessToken = store.getState().accessToken.value;
  const assessmentType = type === 'exitslip' ? 'exit_slip' : type;

  logLearnosityInfo('submit_assessment', { assessmentType, learnerId, sessionId, phase: 'request' });

  if (isTokenExpired()) {
    accessToken = (await refreshTokenOrLogout(getAccessTokenSilently, logout, posthog)) || null;
  }

  try {
    const response = await fetchWithRetry(
      type === 'exitslip' && classExitSlipId
        ? `${import.meta.env.VITE_BFF_URL}/v1/learnosity/${
            assessmentEndpoints[type]
          }?sessionId=${sessionId}&classExitSlipId=${classExitSlipId}`
        : `${import.meta.env.VITE_BFF_URL}/v1/learnosity/${assessmentEndpoints[type]}?sessionId=${sessionId}`,
      {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          ...(sentryTraceId && { 'X-Sentry-Trace-Id': sentryTraceId }),
        },
      },
    );

    logLearnosityInfo('submit_assessment', {
      assessmentType,
      learnerId,
      sessionId,
      phase: 'response',
      status: response.status,
    });
  } catch (error) {
    captureLearnosityException(error, { operation: 'submit_assessment', assessmentType, learnerId, sessionId });
  }
};
